module.exports = __webpack_public_path__ + "static/media/cures.9efb1839.mp3";